// Brand lockup. Defaults to the public /logo.png served by each Pages project.
// All four React apps ship the same /logo.png in their public/ directory.

import type { HTMLAttributes } from 'react';

import { cn } from './cn';

export interface BrandLockupProps extends HTMLAttributes<HTMLDivElement> {
  label?: string;
  size?: 'sm' | 'md' | 'lg';
  src?: string;
}

const sizeStyles: Record<NonNullable<BrandLockupProps['size']>, string> = {
  sm: 'h-8 w-auto',
  md: 'h-10 w-auto',
  lg: 'h-12 w-auto',
};

export function BrandLockup({
  label = 'Fajr Arabi',
  size = 'md',
  src = '/logo.png',
  className,
  ...rest
}: BrandLockupProps) {
  return (
    <div className={cn('inline-flex items-center gap-3', className)} {...rest}>
      <img src={src} alt={label} className={sizeStyles[size]} />
      <span className="font-semibold text-ink-900">{label}</span>
    </div>
  );
}
